import { isDefined } from "@clipboard-health/util-ts";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { FEATURE_FLAG_DEFAULT_VALUES } from "@src/appV2/FeatureFlags/constants";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { useCurrentDate } from "@src/appV2/lib/utils/useCurrentDate";
import { type ClipboardGuidesShiftContext } from "@src/appV2/redesign/Workplace/types";
import { isBefore, parseISO } from "date-fns";

const UPDATE_INTERVAL_MS = 60_000;

interface UseIsClipboardGuidesButtonVisibleParams {
  shiftContext?: ClipboardGuidesShiftContext;
}

export function useIsClipboardGuidesButtonVisible(
  params: UseIsClipboardGuidesButtonVisibleParams
): boolean {
  const { shiftContext } = params;

  const config = useCbhFlag(CbhFeatureFlag.ALCHEMY_CLIPBOARD_GUIDES_EXPERIMENT, {
    defaultValue: FEATURE_FLAG_DEFAULT_VALUES[CbhFeatureFlag.ALCHEMY_CLIPBOARD_GUIDES_EXPERIMENT],
  });

  const currentDate = useCurrentDate(UPDATE_INTERVAL_MS);

  if (!isDefined(shiftContext)) {
    return false;
  }

  if (!config.enabled) {
    return false;
  }

  if (
    config.allowedQualifications.length > 0 &&
    !config.allowedQualifications.includes(shiftContext.qualification)
  ) {
    return false;
  }

  if (shiftContext.isVerified || shiftContext.isDeleted || shiftContext.isClockedOut) {
    return false;
  }

  const cutoffTime = parseISO(shiftContext.shiftEnd);
  if (!isBefore(currentDate, cutoffTime)) {
    return false;
  }

  return true;
}
